import type { FetchControl } from '@/src/types/wallet'

export interface AbCookieConfig {
    [key: string]: string
}

export const isInternalEmail = (email?: string | null): boolean => {
    if (!email) return false
    const normalizedEmail = email.toLowerCase()
    return normalizedEmail.includes('@cleartrip') || normalizedEmail.includes('@flyin')
}

export const getEmailFromUseridCookie = (useridCookie?: string | null): string | null => {
    if (!useridCookie) return null
    try {
        const [email] = decodeURIComponent(useridCookie).split('|')
        return email || null
    } catch {
        return null
    }
}

export const parseAbCookie = (cookieValue?: string | null): AbCookieConfig | null => {
    if (!cookieValue) return null

    try {
        return JSON.parse(decodeURIComponent(cookieValue)) as AbCookieConfig
    } catch {
        return null
    }
}

export const getFetchControl = (
    isCleartripBrand: boolean,
    config?: AbCookieConfig | null,
    forceMultiBrand: boolean = false
): FetchControl => {
    if (forceMultiBrand) return 'ALL'

    const brandDefault: FetchControl = isCleartripBrand ? 'MAIN' : 'ALL'

    if (!config?.bff) return brandDefault

    return config.bff === 'b' ? 'ALL' : 'MAIN'
}
